<template>
  <div class="cm-multiple-select" v-click-outside="closeContainer">
    <div
      class="cm-multiple-select__choice"
      :class="isOpen ? 'cm-multiple-select__choice--opened' : 'cm-multiple-select__choice--closed'"
    >
      <input
        v-model="searchText"
        type="text"
        :placeholder="isOpen ? $t('general.enterName') : ''"
      />

      <i @click="toggleContainer"></i>
      
      <span
        v-if="!isOpen"
        :title="selectedValues"
        @click="isOpen = true"
        class="cm-multiple-select__selected-label"
      >
        {{ selectedValues }}
      </span>
    </div>
    <div
      v-if="isOpen"
      class="cm-multiple-select__options-container"
    >
      <perfect-scrollbar>
        <span
          v-if="!filteredOptions || !filteredOptions.length"
          class="cm-multiple-select__empty"
        >
          Нет вариантов
        </span>

        <div
          v-for="(item, index) in filteredOptions"
          :key="index"
          class="cm-multiple-select__option"
          :class="{'cm-multiple-select__option--active': isActive(item[idKey])}"
          @click="selectOption(item)"
        >
          {{ item[labelKey] }}
          <IconButton
            v-if="isActive(item[idKey])"
            class="cm-multiple-select__delete-btn"
            button="close"
            @click="removeOption(item[idKey])"
          />
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import IconButton from "@/manzana_library/components/Elements/IconButton.vue";

export default {
  name: "CmMultipleSelect",

  components: {
    IconButton
  },

  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array
    },
    labelKey: {
      type: String,
      default: "label"
    },
    idKey: {
      type: String,
      default: "id"
    }
  },

  data() {
    return {
      isOpen: false,
      locValue: [],
      searchText: ""
    }
  },

  computed: {
    filteredOptions() {
      return this.options.filter(i => 
        i[this.labelKey].toLowerCase().includes(this.searchText.toLowerCase())
      );
    },
    selectedValues() {
      return this.value.map(i => i[this.labelKey]).join("; ");
    }
  },

  watch: {
    isOpen(next) {
      if (!next) this.searchText = "";
      next ? this.$emit("open") : this.$emit("close");
    }
  },

  methods: {
    isActive(id) {
      return this.value.find(item => item[this.idKey] == id);
    },
    toggleContainer() {
      this.isOpen = !this.isOpen;
    },
    selectOption(opt) {
      if (this.isActive(opt[this.idKey])) {
        this.removeOption(opt[this.idKey]);
        return;
      }

      this.locValue.push(opt);
      this.$emit("input", this.locValue);
    },
    removeOption(id) {
      this.locValue = this.locValue.filter(item => item[this.idKey] !== id);
      this.$emit("input", this.locValue);
    },
    closeContainer() {
      this.isOpen = false;
    }
  }
}
</script>

<style lang="scss">
.cm-multiple-select {
  width: 100%;
  position: relative;
  &__choice {
    background: $color_white;
    border-radius: 3px;
    box-sizing: border-box;
    display: block;
    color: $color_black;
    position: relative;
    line-height: 100%;
    width: 100%;
    height: 35px;
    cursor: pointer;
    width: 100%;
    height: 100%;

    & > input {
      width: 100%;
      height: 38px;
      padding: 0 25px 0 16px;
    }

    i {
      width: 16px;
      height: 100%;
      position: absolute;
      right: 10px;
    }

    & > i:after {
      content: "";
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      width: 0;
      height: 0;
    }

    &--closed {
      & > i {
        top: 25px;
        &:after {
          border-top: 6px solid #afafaf;
        }
      }
    }

    &--opened {
      .cm-multiple-select__selected-label {
        display: none;
      }

      & > i {
        top: -2px;
        &:after {
          border-bottom: 6px solid #afafaf;
        }
      }

    }
  }

  &__selected-label {
    display: block;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    right: 0;
    top: 10px;
    bottom: 0;
    width: 100%;
    padding-left: 16px;
    padding-right: 30px;
    @include overflow-ellipsis();
  }

  &__options-container {
    background: $color_white;
    border: 0.5px solid #78BE20;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    position: absolute;
    top: 39px;
    left: 0;
    right: 0;
    max-width: 100%;
    z-index: 999;

    .ps {
      max-height: 200px;
    }
  }

  &__empty {
    display: block;
    padding: 9px 14px;
    color: $color_black;
    text-align: center;
  }

  &__option {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 9px 14px;
    color: $color_black;
    &:not(:last-child) {
      border-bottom: 1px solid rgba(167, 167, 167, 0.25);
    }
    &--active {
      color: $color_green-new;
    }
    &:hover {
      background: rgba(102, 204, 0, 0.35);
    }
  }

  &__delete-btn {
    margin: -5px;
    svg {
      fill: $color_error;
      width: 18px;
      height: 18px;
    }

    &:active svg path,
    &:hover svg path,
    &:target svg path {
      fill: $color_error !important;
    }
  }
}
</style>